import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../../utils/axios';
import { SERVICE_URL } from '../Service';
import { RootState } from '../store';

interface State {
    isLoading: boolean;
    error: any;
    workspaceProductData: any;
    liveProductData: any;
    data: {
        deleteData: any;
        selectedProduct: any;
        clientList: any;
        voiceArtistList: any;
    }
}
const initialState: State = {
    isLoading: false,
    error: null,
    workspaceProductData: [],
    liveProductData: [],
    data: {
        deleteData: {},
        selectedProduct: {},
        clientList: {},
        voiceArtistList: {}
    }
}

const slice = createSlice({
    name: 'dashboard',
    initialState,
    reducers: {
        selectedProductData: (state, action) => {
            state.data.selectedProduct = action.payload;
        },
    },
    extraReducers: (builder) => {
        // Add reducers for additional action types here, and handle loading state as needed
        builder.addCase(GetWorkspaceProductData.pending, (state, action) => {
            state.isLoading = true;
        }).addCase(GetWorkspaceProductData.fulfilled, (state, action) => {
            // Add user to the state array
            state.isLoading = false
            state.workspaceProductData = action.payload;
            state.liveProductData = [];
            state.data.deleteData = {}
        }).addCase(GetWorkspaceProductData.rejected, (state, action) => {
            state.isLoading = false
            state.error = action.error
        })


        builder.addCase(GetLiveProductData.pending, (state, action) => {
            state.isLoading = true;
        }).addCase(GetLiveProductData.fulfilled, (state, action) => {
            // Add user to the state array
            state.isLoading = false
            state.liveProductData = action.payload;
            state.workspaceProductData = [];
        }).addCase(GetLiveProductData.rejected, (state, action) => {
            state.isLoading = false
            state.error = action.error
        })

        builder.addCase(deleteProduct.pending, (state, action) => {
            state.isLoading = true;
        }).addCase(deleteProduct.fulfilled, (state, action) => {
            // Add user to the state array
            state.isLoading = false
            state.data.deleteData = action.payload;
        }).addCase(deleteProduct.rejected, (state, action) => {
            state.isLoading = false
            state.error = action.error
        })



        builder.addCase(GetClientList.pending, (state, action) => {
            state.isLoading = true;
        }).addCase(GetClientList.fulfilled, (state, action) => {
            // Add user to the state array
            state.isLoading = false
            state.data.clientList = action.payload;
        }).addCase(GetClientList.rejected, (state, action) => {
            state.isLoading = false
            state.error = action.error
        })

        builder.addCase(GetVoiceArtist.pending, (state, action) => {
            state.isLoading = true;
        }).addCase(GetVoiceArtist.fulfilled, (state, action) => {
            // Add user to the state array
            state.isLoading = false
            state.data.voiceArtistList = action.payload;
        }).addCase(GetVoiceArtist.rejected, (state, action) => {
            state.isLoading = false
            state.error = action.error
        })
    }
})

// Action creators are generated for each case reducer function
export const { selectedProductData } = slice.actions
export const DashboardData = (state: RootState) => state.dashboard;
export default slice.reducer;


export const GetWorkspaceProductData = createAsyncThunk(
    'dashboard/GetWorkspaceProductData',
    async (payload: any, thunkAPI) => {
        const response = await axios.post(SERVICE_URL.GET_WORKSPASEPRODUCT);
        return response.data;
    }
);

export const GetLiveProductData = createAsyncThunk(
    'dashboard/GetLiveProductData',
    async (payload: any, thunkAPI) => {
        const response = await axios.post(SERVICE_URL.GET_LIVEPRODUCT);
        return response.data;
    }
);

export const deleteProduct = createAsyncThunk(
    'dashboard/deleteProduct',
    async (payload: any, thunkAPI) => {
        const response = await axios.post(SERVICE_URL.DELETE_PRODUCT, payload);
        return response.data;
    }
);

export const GetClientList = createAsyncThunk(
    'dashboard/GetClientList',
    async (payload: any, thunkAPI) => {
        const response = await axios.post(SERVICE_URL.GET_CLIENTLIST, payload);
        return response.data;
    }
);
export const GetVoiceArtist = createAsyncThunk(
    'dashboard/GetVoiceArtist',
    async (payload: any, thunkAPI) => {
        const response = await axios.post(SERVICE_URL.GET_VOICEARTIST, payload);
        return response.data;
    }
);